import { render, staticRenderFns } from "./DeviceRomAutoUploadUpdateBox.vue?vue&type=template&id=248e050d"
import script from "./DeviceRomAutoUploadUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceRomAutoUploadUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports